export function uid() {
    return `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

export function toNum(x: number | string | null | undefined) {
    if (x == null || x === "") return null;
    const n = typeof x === "string" ? Number(x.replace(",", ".")) : Number(x);
    return Number.isFinite(n) ? n : null;
}

export function onlyDigits(s: string) {
    return String(s || "").replace(/\D/g, "");
}
